import { h } from 'preact';

import { useCallback } from 'preact/hooks';

import { Match } from 'preact-router/match';

import ListItemButton from '@mui/material/ListItemButton';

import styles from './styles.css';
import { PharosLink } from '../router/router.jsx';
import { PUBLIC_FOLDER } from '../../consts.js';

function contentRenderer(href, children) {
  function onMatch({ matches }) {
    if (matches) {
      return (
        <PharosLink
          href={href}
          activeClassName={styles.activeLink}
          class={styles.link}
        >
          <ListItemButton inset selected>
            {children}
          </ListItemButton>
        </PharosLink>
      );
    } else {
      return (
        <PharosLink
          href={href}
          activeClassName={styles.activeLink}
          class={styles.link}
        >
          <ListItemButton inset>{children}</ListItemButton>
        </PharosLink>
      );
    }
  }

  return onMatch;
}

export default function ReactiveItemLink(props) {
  const { href, children } = props;

  const conditionalMatch = useCallback(contentRenderer(href, children), [
    href,
    children,
  ]);

  return <Match path={`${PUBLIC_FOLDER}${href}`}>{conditionalMatch}</Match>;
}
